import { inject, Injectable, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ApiService } from './http/api.service';
import { ApiResponse, JsonHeader } from '@/app/core/models';
import { firstValueFrom } from 'rxjs';
import { KioskConfig } from '../model/kioskConfig .model';

@Injectable({ providedIn: 'root' })
export class KioskConfigService {
  readonly config = signal<KioskConfig | null>(null);
  private readonly api = inject(ApiService);
  constructor(private http: HttpClient) {}
  
  public loadConfig(): Promise<void> {
  return firstValueFrom(
    this.api.executePostRequest<any[], { MaThamSo: string }>(
        'KIOSK_CAUHINH_SELECT',
        { MaThamSo: '' },
      )
    )
    .then((res: ApiResponse<any[]>) => {
    this.config.set(this.mapConfig(res.Data));
    })
    .catch(err => {
    console.error('Không load được kiosk config', err);
    this.config.set(null);
    });
  }

  /* ===== MAP DATA ===== */
  private mapConfig(params: any[]): KioskConfig {
    const get = (key: string) => params.find((p) => p.MaThamSo === key)?.GiaTri ?? '';

    const toBool = (v: string) => v === '1';

    return {
      logo: get('Logo'),
      hospitalName: get('Name'),
      apiHIS: get('ApiHIS'),
      background: get('Background'),
      videoIdle: get('Video'),

      features: {
        tittle: toBool(get('Tittle')),
        laySoDangKy: toBool(get('LaySoDangKy')),
        khamBH: toBool(get('KhamBH')),
        khamDV: toBool(get('KhamDV')),
        traCuuGia: toBool(get('TraCuuGia')),
        traCuuTT: toBool(get('TraCucTT')),
        thanhToan: toBool(get('ThanhToan')),
        khaoSat: toBool(get('KhaoSat')),
        doThiLuc: toBool(get('DoThiLuc')),
        content: toBool(get('Content')),
      },

      featureText: {
        tittle: get('Tittle'),
        laySoDangKy: get('LaySoDangKyText'),
        khamBH: get('KhamBHText'),
        khamDV: get('KhamDVText'),
        traCuuGia: get('TraCuuGiaText'),
        traCuuTT: get('TraCucTTText'),
        thanhToan: get('ThanhToanText'),
        khaoSat: get('KhaoSatText'),
        content: get('Content'),
        taiKhamText: get('TaiKhamText')
      }
    };
  }
}
